export default "__VITE_ASSET__CtSu1lr1__"